import { WebPlugin } from '@capacitor/core';
export class BottomSheetWeb extends WebPlugin {
    async showActions(data) {
        console.log("pwa-action-sheet");
        return new Promise((resolve, _reject) => {
            let actionSheet = document.querySelector('pwa-action-sheet');
            if (!actionSheet) {
                actionSheet = document.createElement('pwa-action-sheet');
                document.body.appendChild(actionSheet);
            }
            actionSheet.cancelable = false;
            actionSheet.options = data.options;
            actionSheet.addEventListener('onSelection', async (e) => {
                const selection = e.detail;
                resolve({
                    value: selection,
                });
            });
        });
    }
}
//# sourceMappingURL=web.js.map